import * as React from 'react';

import { mergeStyles } from '@cian/utils';
import { plural } from '@cian/utils/lib/shared/plural';
import { getAccountTypeTitle } from './utils';

const style = require('./index.css');

export interface ISimilarProps {
  count: number;
  url: string;
  isTop3?: boolean;
  isColorized?: boolean;
  trackAllDuplicatesClick?(): void;
  agencyName?: string;
  accountType?: string;
}

export class Similar extends React.Component<ISimilarProps> {

  public render() {
    const {
      isColorized,
      isTop3,
      url,
    } = this.props;

    return (
      <a
        href={url}
        rel="nofollow noopener"
        onClick={this.trackClickEvent}
        target="_blank"
        {...mergeStyles(
          style['similar'],
          isTop3 && style['similar--top3'],
          isColorized && style['similar--colorized'],
        )}
      >
        {this.renderCommercialLinkText()}
      </a>
    );
  }

  private renderCommercialLinkText() {
    const { count, agencyName, accountType } = this.props;
    const offersText = `${plural(count, ['предложение', 'предложения', 'предложений'])}`;
    const userText = agencyName ? getAccountTypeTitle(accountType, agencyName) : 'агента';

    return `Ещё ${count} ${offersText} от ${userText} в этом здании`;
  }

  private trackClickEvent = () => {
    const { trackAllDuplicatesClick } = this.props;
    if (trackAllDuplicatesClick) {
      trackAllDuplicatesClick();
    }
  }
}
